export default "__VITE_ASSET__kcjZJrKA__"